import styled from "styled-components";
import {isMobile} from "../../commonmethod/CommonMethod";

export const InputSearch = styled.input`
  border:  1px hsl(214.3, 31.8%, 91.4%) solid;
  line-height: 30px;
  min-width:${props => props.isMobile ? '100%' : '300px'};
  padding: 0 10px;
  height: ${props => props.isMobile ? '35px' : '32px'};
  color: #5c5c5d;
  outline: none;
  border-radius: 4px; 
  margin-right: 8px;

    &:hover {
        border: 1px hsl(240, 2%, 22%) solid;
    }
`;


export const InputSearchOption = styled.input`
    border:  1px hsl(214.3, 31.8%, 91.4%) solid;
    line-height: 30px;
    width: calc(100% - 80px);
    padding: 0 10px;
    border-radius:0px;
    height: ${props => props.isMobile ? '35px' : '30px'};
    color: #5c5c5d;
    outline: none;
    margin-left: 5px;
`;
export const DatePeri0dPicker = styled.button`
  border: 1px solid #d0d0d0;
  line-height: 30px;
  padding: 0 15px;
  text-align: center;
  height: 30px;
  margin-right: 5px;
  margin-left: 5px;
`;